// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useEffect } from 'react';

import { useEvolveGet } from '@evolvemep/api-ts';

import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { WrappedMultiSelect } from 'components/Mantine/TypeSafeSelect/WrappedMultiSelect';
import { isNil } from 'helpers/isNotNil';
import { validateUserNameOrEmail } from 'helpers/userHelpers';

export const AssigneesFilter = ({ filter: route, value, onChange, defaultParams }: GlobalFilterProps<'assignees'>) => {
  const {
    data: assigneeList,
    loading: loadingAssignees,
    setDefaultOpts,
  } = useEvolveGet(route ?? 'shop/workOrder/assignedUsers');
  useEffect(() => {
    setDefaultOpts({
      lazy: isNil(route),
      defaultConfig: {
        params: defaultParams,
      },
    });
  }, [defaultParams, route, setDefaultOpts]);
  if (!route) return null;
  return (
    <WrappedMultiSelect
      value={value.map((u) => u.userId)}
      onChange={(v) => onChange(assigneeList?.filter((u) => v.includes(u.userId)) ?? [])}
      loading={loadingAssignees}
      data={
        assigneeList?.map((m) => ({
          label: validateUserNameOrEmail(m),
          value: m.userId,
        })) ?? []
      }
      label="Assignees"
      placeholder="All Assignees"
      searchable
      clearable
      comboboxProps={{
        withinPortal: false,
      }}
    />
  );
};
